module.exports = __webpack_public_path__ + "static/forklift-898fed13e80f1c7be25d6304bfa440c7.png";